import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {KeycloakLv1871Service} from '../../../lib-core/services/keycloak-lv1871.service';
import {UiInputControl} from '../../models/uiArtefakt';
import {HttpClient} from '@angular/common/http';
import {RuntimeContext, UiConfigService} from '@lv1871/core';
import {EventService} from '../../services/event.service';
import {switchMap, take, withLatestFrom} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {KundenTrefferDialogComponent} from './kunden-treffer-dialog/kunden-treffer-dialog.component';
import {UiControl} from '../../models/uiControl';
import {of, Subject} from 'rxjs';
import {Kundensuche} from '../../models/kundensuche';
import {UiModelService} from '../../services/ui-model.service';
import {ShellConfigService} from '../../services/shell-config.service';

@Component({
    selector: 'lv-kundensuche',
    templateUrl: './kundensuche.component.html',
    styleUrls: ['./kundensuche.component.scss'],
    standalone: false
})
export class KundensucheComponent implements OnInit, AfterViewInit {

  @Input()
  public uiArtefakt: UiInputControl;

  refIdentTouchedOrDirty$: Subject<string>;
  refIdent: string;

  constructor(private _keycloakService: KeycloakLv1871Service, private _http: HttpClient, private _configService: UiConfigService,
              private _eventService: EventService, private _matDialog: MatDialog, private _uiModelService: UiModelService,
              private _renderer: Renderer2, private _element: ElementRef, private _shellConfigService: ShellConfigService) {
  }

  ngOnInit(): void {
    this.refIdent = this.uiArtefakt.Identifikator + '@' + this.uiArtefakt.WertEingabe;
    this.refIdentTouchedOrDirty$ = this._eventService.refIdentTouchedOrDirty$;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public search() {
    this._eventService.uiControls$.pipe(
        take(1),
        switchMap(control => {
          const refIdent = this.uiArtefakt.ReferenzListItemKey ? this.uiArtefakt.ReferenzListItemKey : this.uiArtefakt.Identifikator;
          return this._http.post<Kundensuche>(
              this._configService.getAntragserfassungUrl() + '/api/produkt/kundensuche/' + refIdent, {
                vorgang: control.uiVorgang,
                pageIndex: 0,
                elementsPerPage: 12
              })
              .pipe(withLatestFrom(of(control)));
        })
    ).subscribe(([kundensuche, control]) => {
      kundensuche.identifikator = this.uiArtefakt.Identifikator;
      kundensuche.vorgang = control.uiVorgang;
      this._openKundenDialog(kundensuche);
    });
  }

  public kundensucheEnabled(): boolean {
    return this._keycloakService.hasRole('Antragsdatenerfassung');
  }

  private _openKundenDialog(kundensuche: Kundensuche) {
    let matDialogMinWidth = '80%';
    let matDialogWidth = '80%';
    if (this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL) {
      matDialogMinWidth = '100%';
      matDialogWidth = '100%';
    }
    this._matDialog.open<KundenTrefferDialogComponent, Kundensuche, number>(KundenTrefferDialogComponent, {
      panelClass: 'lv-modal-dialog',
      data: kundensuche,
      disableClose: false,
      autoFocus: false,
      minWidth: matDialogMinWidth,
      width: matDialogWidth,
      maxHeight: '80%'
    }).afterClosed().subscribe(knr => {
          if (!!knr) {
            const refIdent = this.uiArtefakt.ReferenzListItemKey ? this.uiArtefakt.ReferenzListItemKey : this.uiArtefakt.Identifikator;
            this._eventService.uiControls$.pipe(
                take(1),
                switchMap(control => this._http.post<UiControl>(
                    this._configService.getAntragserfassungUrl() + '/api/produkt/kundenupdate/' + refIdent + '/' + knr, control))
            ).subscribe(control => {
              this._eventService.uiControls$.next(control);
              this._eventService.uiControlsNewst$.next(control);
              this._uiModelService.requestUiControl(control).subscribe();
            });
          }
        }
    );
  }
}
